import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import { useMemo, useRef } from "react";
import Layout from "../../../common/Layout";
import HeaderTwo from "../../../common/header/HeaderTwo";
import FooterOne from "../../../common/footer/FooterOne";

const LearningSpace = () => {
  const galleryRef = useRef(null);
  let isDragging = false;

  const images = [
    {
      name: "Denpasar Learning Center",
      city: "Denpasar",
      address: "Jl. Buluh Indah No.56, Pemecutan Kaja, Denpasar",
      img: "assets/images/banner/learning-spaces/denpasar-learning.webp",
    },
    {
      name: "Bandung Learning Center",
      city: "Bandung",
      address: "Point Lab Co-working Space, Jl. Banda No.30 2nd floor",
      img: "assets/images/banner/learning-spaces/bandung-learning.webp",
    },
    {
      name: "Jakarta-Tangerang Learning Center",
      city: "Jakarta & Tangerang",
      address: "MULA by Galeria -Jakarta & Sanctuary Bintaro - Tanggerang",
      img: "assets/images/banner/learning-spaces/jakarta-learning.webp",
    },
    {
      name: "Makassar Learning Center",
      city: "Makassar",
      address: "Bikin Bikin Creative Hub, Panakukang, Nipah Mall 4th floor",
      img: "assets/images/banner/learning-spaces/makassar-learning.webp",
    },
    {
      name: "Medan Learning Center",
      city: "Medan",
      address: "GoWork Sinar Mas Land Plaza",
      img: "assets/images/banner/learning-spaces/medan-learning.webp",
    },
    {
      name: "Surabaya Learning Center",
      city: "Surabaya",
      address: "Voza Tower Hub. 8th floor",
      img: "assets/images/banner/learning-spaces/surabaya-learning.webp",
    },
  ];

  // const shuffleArray = (array) => {
  //   const result = [...array];
  //   for (let i = result.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1));
  //     [result[i], result[j]] = [result[j], result[i]];
  //   }
  //   return result;
  // };  

  // const shuffledImages = useMemo(() => {
  //   return shuffleArray(images);
  // }, []);  

  return (
    <div>
      <HeaderTwo id="top-header" />
      <section className="section-padding">
        <div className="container">
          <LightGallery
            onInit={(ref) => (galleryRef.current = ref.instance)}
            plugins={[lgZoom, lgThumbnail]}
            download={false}
            dynamic
            dynamicEl={images.map((img) => ({
              src: img.img,
              thumb: img.img,
              subHtml: `
                  <p>${img.name}</p>
                `,
            }))}
          />
          <div className="pb-5 mt-5 mt-md-0">
            <h2 className="text-center">Fasilitas Belajar Kami</h2>
            <p className="text-center">Tempat belajar yang nyaman dan inspiratif untuk tumbuh dan berkembang bersama.</p>
          </div>
          {images.map((img, index) => (
            <div key={img.name} className="learning-space-wrapper">
              <h5 className="text-center">{`Ruang Belajar ${img.city}`}</h5>
              <p className="text-center mb-3">{img.address}</p>
              <img
                src={img.img}
                className="img-fluid p-1"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (!isDragging) {
                    galleryRef.current.openGallery(index);
                  }
                }}
              />
            </div>
          ))}
        </div>
      </section>
      <FooterOne />
    </div>
  );
}

export default LearningSpace;